// src/components/Footer.jsx
import React from "react";

const Footer = () => {
  return (
    <>
      <hr />
      <footer className="bg-white text-black py-12 mt-10">
        <div className="container mx-auto px-6 md:flex md:justify-between md:items-start gap-8">

          {/* Brand Info */}
          <div className="mb-8 md:mb-0 md:w-1/3">
            <h2
              className="text-2xl font-bold bg-gradient-to-r from-green-600 via-emerald-500 to-lime-400 bg-clip-text text-transparent"
            >
              ZajraGreen
            </h2>

            <p className="mt-2 text-sm sm:text-base text-gray-700 leading-relaxed">
              We specialize in premium turf construction for football grounds, box cricket arenas,
              multisport courts, and recreational surfaces — delivering durable and high-performance sports turfs across India.
            </p>
          </div>

          {/* Links */}
          <div className="grid grid-cols-2 gap-8 sm:grid-cols-3 md:w-2/3">

            {/* Quick Links */}
            <div>
              <h3 className="mb-3 font-semibold text-black text-lg sm:text-base">
                Quick Links
              </h3>
              <ul className="space-y-2 text-sm">
                <li>
                  <a
                    href="/"
                    className="text-black hover:!text-green-600 focus:text-green-600 transition-colors duration-300"
                  >
                    Home
                  </a>
                </li>

                <li>
                  <a
                    href="/about"
                    className="text-black hover:!text-green-600 focus:text-green-600 transition-colors duration-300"
                  >
                    About Us
                  </a>
                </li>

               

                <li>
                  <a
                    href="/projects"
                    className="text-black hover:!text-green-600 focus:text-green-600 transition-colors duration-300"
                  >
                    Projects
                  </a>
                </li>

                <li>
                  <a
                    href="/contact"
                    className="text-black hover:!text-green-600 focus:text-green-600 transition-colors duration-300"
                  >
                    Contact
                  </a>
                </li>
              </ul>
            </div>

            {/* Support */}
            <div>
              <h3 className="mb-3 font-semibold text-black text-lg sm:text-base">
                Support
              </h3>
              <ul className="space-y-2 text-sm">
                <li>
                  <a
                    href="/faq"
                    className="text-black hover:!text-green-600 focus:text-green-600 transition-colors duration-300"
                  >
                    FAQ
                  </a>
                </li>

                <li>
                  <a
                    href="/privacy-policy"
                    className="text-black hover:!text-green-600 focus:text-green-600 transition-colors duration-300"
                  >
                    Privacy Policy
                  </a>
                </li>

                <li>
                  <a
                    href="/terms-of-service"
                    className="text-black hover:!text-green-600 focus:text-green-600 transition-colors duration-300"
                  >
                    Terms & Conditions
                  </a>
                </li>
              </ul>
            </div>

            {/* Social */}
            <div>
              <h3 className="mb-3 font-semibold text-black text-lg sm:text-base">
                Follow Us
              </h3>
              <ul className="space-y-2 text-sm">
                <li>
                  <a
                    href=""
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-black hover:!text-green-600 focus:text-green-600 transition-colors duration-300"
                  >
                    Instagram
                  </a>
                </li>

                <li>
                  <a
                    href=""
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-black hover:!text-green-600 focus:text-green-600 transition-colors duration-300"
                  >
                    Facebook
                  </a>
                </li>

                <li>
                  <a
                    href=""
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-black hover:!text-green-600 focus:text-green-600 transition-colors duration-300"
                  >
                    WhatsApp
                  </a>
                </li>
              </ul>
            </div>

          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
